import React from "react";
import MotivosBaseTemplate from "../motivos/shared/MotivosBaseTemplate";
import {
  alterarStatusPostoOrigem,
  cadastrarPostoOrigem,
  editarPostoOrigem,
  excluirPostoOrigem,
  listarPostosOrigem,
} from "./postosOrigem.api";

export default function PostosOrigemBase() {
  return (
    <MotivosBaseTemplate
      titulo="Postos de Origem"
      descricao="Cadastre os postos de origem usados nas interdicoes operacionais do CIM."
      placeholder="Ex.: LIC"
      hint="Use esta base para centralizar os postos de origem do CIM."
      listFn={listarPostosOrigem}
      createFn={cadastrarPostoOrigem}
      updateFn={editarPostoOrigem}
      deleteFn={excluirPostoOrigem}
      toggleFn={alterarStatusPostoOrigem}
    />
  );
}
